    
<template>
  <common-page-layout>     
    <span slot="fixedtopbuttons">
      <new-button v-if="sysadmin" @click="newBusiness()"></new-button>    
      <large-button v-if="sysadmin" @click="getFullBusinesssListing()">All..</large-button> 
      <large-button @click="refresh">Refresh</large-button>
      <!-- <clone-button v-if="sysadmin || (adminrights && adminrights.write && business && business.cancreatefranchisee)" @click="cloneBusiness()">{{business.name}}</clone-button> -->
    </span>
    <p :key="index" v-for="(alladminright,index) in businessrights">    
        <large-button-wide class="w3-theme-dark"
                        @click="$refs.businessdialogmenulayout.show({business:{id:index},meta:index})">
                        <b>{{alladminright.name}}</b> (about)  
        </large-button-wide>
    </p>

    <dialog-layout ref="addbusinessialog" id="addbusinessialog" @click="dialogActions">           
        
        <h3 slot-scope="slotScope" slot="headercontent">{{slotScope.meta && slotScope.meta.id?'Clone ' +slotScope.meta.existingname :'New Business'}}</h3>              
        
        <span v-if="slotScope && slotScope.meta" slot-scope="slotScope">          

          <p>
            <label class="w3-text-grey">Name (required)</label>
            <input class="w3-input w3-border" placeholder="This is required" max="75" maxlength="75" v-model="slotScope.meta.name"/>            
            <font color="red">Name is required.</font>
          </p>     

          <p>
            <label class="w3-text-grey">Name2</label>
            <input class="w3-input w3-border" max="75" maxlength="75" v-model="slotScope.meta.name2"/>     
          </p> 

          <p>
            <label class="w3-text-grey">Short Name (required)</label>
            <input class="w3-input w3-border" placeholder="This is required" max="75" maxlength="75" v-model="slotScope.meta.shortname"/>
            <font color="red">Used to display short name for display and PWA name.</font>            
          </p>         
         
          <p>
            <label class="w3-text-grey">Cellphone</label>
            <input type="tel" class="w3-input w3-border" style="resize:none" v-model="slotScope.meta.phone"/>
          </p>

          <p>
            <label class="w3-text-grey">Phone</label>
            <input type="tel" class="w3-input w3-border" style="resize:none" v-model="slotScope.meta.phone2"/>
          </p>

          <p>
            <label class="w3-text-grey">Contact Email</label>
            <input type="text" class="w3-input w3-border" style="resize:none" v-model="slotScope.meta.email"/>
          </p>

          <p>
            <label class="w3-text-grey">Website</label>
            <input type="text" class="w3-input w3-border" style="resize:none" v-model="slotScope.meta.website"/>
          </p>

          <large-button v-if="slotScope.meta.name" @click="createBusiness(slotScope.meta)">Create</large-button> 

        </span>        
                        
                                         
    </dialog-layout>
  
    <business-dialog ref="businessdialogmenulayout">   
          <span slot="general">
              <p><font color="red">WARNING!!! Here you have access to change, clone or remove Businesses, this is a one way process and cannot be undone. If in doubt contact your FIBI administrator.</font></p>
          </span>       
          
          <template slot-scope="slotProps"> 

            <large-button
              v-if="slotProps.business && (business.id !== slotProps.business.id)"
              @click="changeBusiness(slotProps.business.id);$refs.businessdialogmenulayout.cancelDialog()">Change to {{slotProps.business.name}}
            </large-button>                 

            <confirm-dialog 
              v-if="sysadmin && slotProps.business && slotProps.business.name!=='FIBI' && (business.id !== slotProps.business.id)"
              usedefaultbutton buttontext="Remove Business" id="removebusiness" @click="actionremovebusiness($event,slotProps.business)" oktext="Yes Remove">        
              Warning removing "{{slotProps.business.name}}" this cannot be undone, please double check.
            </confirm-dialog>

            <large-button
              v-if="!slotProps.business"
              @click="selfgroupcommands({command:'removeMyselfFromGroup',business:{id:slotProps.meta}});$refs.businessdialogmenulayout.cancelDialog()">Remove from list
            </large-button>                 
            
          </template>
    </business-dialog>

  </common-page-layout>
</template>

<script>
  import {
    mapGetters,
    mapActions
  } from "vuex";
  // var mounted=true;
  export default {
    data: function() {
      return {        
        businessrights:null
      }
    },
    methods: {
      dialogActions(e){
        if(e.action==="canceldialog")
        {             
        }        
      },
      refresh(){
          this.businessrights = this.alladminrights
      },
      actionremovebusiness(e,business){
        if(e.action){
          this.$refs.businessdialogmenulayout.cancelDialog()
          this.businesscommands({command:'removeBusiness',business})
        }        
      },
      createBusiness(business){  
        let command = 'createBusiness'//default
        
        if(business.id)
          command = 'cloneBusiness'
          
        this.businesscommands({command,business})

        this.$refs.addbusinessialog.cancelDialog()          

      },
      newBusiness(id,name){                            
          this.$refs.addbusinessialog.show({}) 
      },
      cloneBusiness(){     
          let clone = {
            id:this.business.id,
            existingname:this.business.name
          }

          this.$refs.addbusinessialog.show(clone)           
      },
      getFullBusinesssListing(){
          this.fullbusiness().then((fs)=>{ 
            let businessslist = Object.keys(fs).reduce((accum,key)=>{
                let business = fs[key]
                accum[key] = {name:business.name}
                return accum
            },{})                       
            this.businessrights = businessslist
          })
      },
      ...mapActions(['changeBusiness','businesscommands','fullbusiness','selfgroupcommands'])
    },
    computed: {
      ...mapGetters(["adminrights","alladminrights","sysadmin","business"])
    },    
    created(){
      this.businessrights = this.alladminrights
    }
  
  };
</script>
 


// WEBPACK FOOTER //
// src/components/BusinessSelect.vue